/* eslint-disable */
import React, { useState, useContext, useEffect } from 'react'
import styles from './index.module.scss'
import Useful from '../../components/pages/useful'
import { PageContext } from '../../context/PageContextProvider'
import { Info, Teqvim } from '../../icons'
import {
  summary2026,
  quarters as quarters2026,
  weekdayHeaders,
  months2026,
} from './calendarData2026'
import {
  summary2025,
  quarters2025,
  months2025,
} from './calendarData2025'

const Calendar = ({ className }) => {
  const { language } = useContext(PageContext)
  const [activeYear, setActiveYear] = useState('2026') // Default: 2026
  const [selectedQuarter, setSelectedQuarter] = useState(0)
  const [activeNotice, setActiveNotice] = useState(null)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  // Active dataset based on selected year
  const activeSummary = activeYear === '2026' ? summary2026 : summary2025
  const activeQuarters = activeYear === '2026' ? quarters2026 : quarters2025
  const activeMonths = activeYear === '2026' ? months2026 : months2025

  const titles = {
    main: {
      AZ: `${activeYear}-cı ilin İstehsalat Təqvimi və İş Vaxtı Norması`,
      ENG: `${activeYear} Production Calendar and Working Hours Norms`,
      RU: `Производственный календарь и нормы рабочего времени на ${activeYear} год`,
      TR: `${activeYear} Yılı Üretim Takvimi ve Çalışma Süresi Normları`,
    },
    sub: {
      AZ: 'Azərbaycan Respublikası Əmək və Əhalinin Sosial Müdafiəsi Nazirliyinin Kollegiyasının rəsmi qərarına əsasən təsdiq edilmişdir.',
      ENG: 'Approved according to the official decree of the Ministry of Labor and Social Protection of Population of the Republic of Azerbaijan.',
      RU: 'Утверждено в соответствии с официальным постановлением Министерства труда и социальной защиты населения Азербайджанской Республики.',
      TR: 'Azerbaycan Cumhuriyeti Çalışma ve Sosyal Güvenlik Bakanlığı resmi kararına istinaden onaylanmıştır.',
    },
    allYear: { AZ: 'Bütün İl (12 ay)', ENG: 'Full Year (12 months)', RU: 'Весь год (12 месяцев)', TR: 'Tüm Yıl (12 ay)' },
    workDays: { AZ: 'İş günləri', ENG: 'Work days', RU: 'Рабочие дни', TR: 'İş günleri' },
    nonWorkDays: { AZ: 'Qeyri-iş günləri', ENG: 'Non-working days', RU: 'Выходные дни', TR: 'Tatil günleri' },
    workHours: { AZ: 'İş saatı norması (40s)', ENG: 'Working hours (40h)', RU: 'Рабочие часы (40ч)', TR: 'Çalışma saati normu (40s)' },
    totalDays: { AZ: 'Təqvim günləri', ENG: 'Calendar days', RU: 'Календарные дни', TR: 'Takvim günleri' },
    day: { AZ: 'gün', ENG: 'days', RU: 'дней', TR: 'gün' },
    hour: { AZ: 'saat', ENG: 'hours', RU: 'часов', TR: 'saat' },
    normalWork: { AZ: 'İş günü', ENG: 'Working day', RU: 'Рабочий день', TR: 'İş günü' },
    holiday: { AZ: 'Bayram / Qeyri-iş', ENG: 'Holiday / Non-working', RU: 'Праздничный / Выходной', TR: 'Bayram / Tatil' },
    shortened: { AZ: '1 saat qısaldılmış gün (7s)', ENG: '1h shortened day (7h)', RU: 'Сокращенный день на 1ч', TR: '1 saat kısaltılmış gün (7s)' },
    weekend: { AZ: 'Həftəsonu', ENG: 'Weekend', RU: 'Выходной', TR: 'Hafta sonu' },
    close: { AZ: 'Bağla', ENG: 'Close', RU: 'Закрыть', TR: 'Kapat' },
    quarterTotal: { AZ: 'Rüb üzrə cəmi:', ENG: 'Quarter total:', RU: 'Итого за квартал:', TR: 'Çeyrek toplamı:' },
    officialInfo: {
      AZ: 'Rəsmi Qərar və İş Vaxtı Normaları',
      ENG: 'Official Decision and Working Time Norms',
      RU: 'Официальное постановление и нормы рабочего времени',
      TR: 'Resmi Karar ve Çalışma Süresi Normları',
    },
    workDaysLabel: { AZ: 'İş günləri:', ENG: 'Work days:', RU: 'Рабочие дни:', TR: 'İş günleri:' },
    workHoursLabel: { AZ: 'İş saatı:', ENG: 'Work hours:', RU: 'Рабочие часы:', TR: 'Çalışma saati:' },
    overview: { AZ: 'İcmalı', ENG: 'Overview', RU: 'Обзор', TR: 'Genel Bakış' },
    hoursShort: { AZ: 's', ENG: 'h', RU: 'ч', TR: 's' },
  }

  const kpis = [
    {
      icon: '📅',
      val: activeSummary.totalDays,
      unit: titles.day[language] || titles.day.AZ,
      label: titles.totalDays[language] || titles.totalDays.AZ,
      variant: 'primary',
    },
    {
      icon: '💼',
      val: activeSummary.workDays,
      unit: titles.day[language] || titles.day.AZ,
      label: titles.workDays[language] || titles.workDays.AZ,
      variant: 'success',
    },
    {
      icon: '🏖️',
      val: activeSummary.nonWorkDays,
      unit: titles.day[language] || titles.day.AZ,
      label: titles.nonWorkDays[language] || titles.nonWorkDays.AZ,
      variant: 'danger',
    },
    {
      icon: '⏱️',
      val: activeSummary.workHours40.toLocaleString('az-AZ'),
      unit: titles.hour[language] || titles.hour.AZ,
      label: titles.workHours[language] || titles.workHours.AZ,
      variant: 'warning',
    },
  ]

  const handleDayClick = (month, day, special) => {
    const dayOfWeek = (month.startOffset + day - 1) % 7
    const isWknd = dayOfWeek === 5 || dayOfWeek === 6

    let text = ''
    if (special) {
      text = special.title[language] || special.title.AZ
    } else if (isWknd) {
      text = language === 'AZ' ? 'Həftəlik istirahət günü' : language === 'RU' ? 'Выходной день' : language === 'TR' ? 'Haftalık dinlenme günü' : 'Weekend non-working day'
    } else {
      text = language === 'AZ' ? 'Tam iş günü (8 saatlıq iş vaxtı)' : language === 'RU' ? 'Полный рабочий день (8 часов)' : language === 'TR' ? 'Tam iş günü (8 saatlik çalışma süresi)' : 'Regular working day (8 hours)'
    }

    setActiveNotice({
      dateStr: `${day} ${month.name[language] || month.name.AZ} ${activeYear}`,
      text,
    })
  }

  const filteredMonths = activeMonths.filter(
    (m) => selectedQuarter === 0 || m.quarter === selectedQuarter
  )

  return (
    <section className={`${styles.container} ${className || ''}`}>
      <Useful search={false} />

      {/* Year Switcher Tabs */}
      <div className={styles.yearSwitcher}>
        <button
          type="button"
          className={activeYear === '2026' ? styles.active : ''}
          onClick={() => { setActiveYear('2026'); setSelectedQuarter(0); }}
        >
          {`2026 · ${language === 'AZ' ? 'Cari / Aktual' : language === 'RU' ? 'Текущий' : language === 'TR' ? 'Güncel' : 'Current'}`}
        </button>
        <button
          type="button"
          className={activeYear === '2025' ? styles.active : ''}
          onClick={() => { setActiveYear('2025'); setSelectedQuarter(0); }}
        >
          2025
        </button>
      </div>

      <h1>{titles.main[language] || titles.main.AZ}</h1>
      <p className={styles.subtitle}>{titles.sub[language] || titles.sub.AZ}</p>

      {/* KPI Grid */}
      <div className={styles.kpiGrid}>
        {kpis.map((k, idx) => (
          <div key={idx} className={`${styles.kpiCard} ${styles[k.variant]} bpg-card-neon`}>
            <div className={styles.kpiIcon}>{k.icon}</div>
            <div className={styles.kpiValue}>
              {k.val} <span style={{ fontSize: 16, fontWeight: 500 }}>{k.unit}</span>
            </div>
            <div className={styles.kpiLabel}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Filter Navigation & Legend */}
      <div className={styles.filterBar}>
        <div className={styles.tabs}>
          <button
            type="button"
            className={selectedQuarter === 0 ? styles.active : ''}
            onClick={() => setSelectedQuarter(0)}
          >
            {titles.allYear[language] || titles.allYear.AZ}
          </button>
          {activeQuarters.map((q) => (
            <button
              key={q.id}
              type="button"
              className={selectedQuarter === q.id ? styles.active : ''}
              onClick={() => setSelectedQuarter(q.id)}
            >
              {q.name[language] || q.name.AZ}
            </button>
          ))}
        </div>

        <div className={styles.legend}>
          <div className={styles.legendItem}>
            <div className={`${styles.dot} ${styles.work}`} />
            <span>{titles.normalWork[language] || titles.normalWork.AZ}</span>
          </div>
          <div className={styles.legendItem}>
            <div className={`${styles.dot} ${styles.holiday}`} />
            <span>{titles.holiday[language] || titles.holiday.AZ}</span>
          </div>
          <div className={styles.legendItem}>
            <div className={`${styles.dot} ${styles.shortened}`} />
            <span>{titles.shortened[language] || titles.shortened.AZ}</span>
          </div>
          <div className={styles.legendItem}>
            <div className={`${styles.dot} ${styles.weekend}`} />
            <span>{titles.weekend[language] || titles.weekend.AZ}</span>
          </div>
        </div>
      </div>

      {/* Active Day Notification */}
      {activeNotice && (
        <div className={styles.activeDayNotice}>
          <div>
            <strong>{activeNotice.dateStr}: </strong>
            <span>{activeNotice.text}</span>
          </div>
          <button type="button" onClick={() => setActiveNotice(null)} aria-label="Bağla">
            ✕
          </button>
        </div>
      )}

      {/* 12 Months Calendar Grid */}
      <div className={styles.calendarGrid}>
        {filteredMonths.map((month) => {
          const emptyCells = Array.from({ length: month.startOffset })
          const days = Array.from({ length: month.days }, (_, i) => i + 1)
          const qName = activeQuarters[month.quarter - 1]?.name[language] || activeQuarters[month.quarter - 1]?.name.AZ

          return (
            <div key={month.index} className={`${styles.monthCard} bpg-card-neon`}>
              <div className={styles.monthHeader}>
                <h3>{month.name[language] || month.name.AZ}</h3>
                <span className={styles.quarterBadge}>{qName}</span>
              </div>

              <div className={styles.monthStats}>
                <span>{titles.workDaysLabel[language] || titles.workDaysLabel.AZ} <strong>{month.workDays}</strong></span>
                <span>{titles.workHoursLabel[language] || titles.workHoursLabel.AZ} <strong>{month.workHours}{titles.hoursShort[language] || 's'}</strong></span>
              </div>

              <div className={styles.weekdaysHeader}>
                {(weekdayHeaders[language] || weekdayHeaders.AZ).map((d, i) => (
                  <div key={i}>{d}</div>
                ))}
              </div>

              <div className={styles.daysGrid}>
                {emptyCells.map((_, i) => (
                  <div key={`empty-${i}`} className={`${styles.dayCell} ${styles.empty}`} />
                ))}
                {days.map((day) => {
                  const dayOfWeek = (month.startOffset + day - 1) % 7
                  const isWeekend = dayOfWeek === 5 || dayOfWeek === 6
                  const special = month.specialDays[day]

                  let dayClass = ''
                  if (special) {
                    if (special.type === 'holiday') dayClass = styles.holiday
                    else if (special.type === 'shortened') dayClass = styles.shortened
                    else if (special.type === 'mourning') dayClass = styles.mourning
                  } else if (isWeekend) {
                    dayClass = styles.weekend
                  }

                  return (
                    <div
                      key={day}
                      className={`${styles.dayCell} ${dayClass}`}
                      onClick={() => handleDayClick(month, day, special)}
                      title={special ? (special.title[language] || special.title.AZ) : ''}
                    >
                      {day}
                    </div>
                  )
                })}
              </div>
            </div>
          )
        })}
      </div>

      {/* Selected Quarter Summary Banner if a single quarter is selected */}
      {selectedQuarter !== 0 && (
        <div className={styles.quarterSummaryBanner}>
          <h4>
            {activeQuarters[selectedQuarter - 1]?.name[language] || activeQuarters[selectedQuarter - 1]?.name.AZ}{' '}
            {titles.overview[language] || titles.overview.AZ} ({activeQuarters[selectedQuarter - 1]?.period[language] || activeQuarters[selectedQuarter - 1]?.period.AZ})
          </h4>
          <div className={styles.quarterMetrics}>
            <span>{titles.workDaysLabel[language] || titles.workDaysLabel.AZ} <strong>{activeQuarters[selectedQuarter - 1]?.workDays} {titles.day[language] || titles.day.AZ}</strong></span>
            <span>{titles.nonWorkDays[language] || titles.nonWorkDays.AZ}: <strong>{activeQuarters[selectedQuarter - 1]?.nonWorkDays} {titles.day[language] || titles.day.AZ}</strong></span>
            <span>{titles.workHours[language] || titles.workHours.AZ}: <strong>{activeQuarters[selectedQuarter - 1]?.workHours} {titles.hour[language] || titles.hour.AZ}</strong></span>
          </div>
        </div>
      )}

      {/* Official Legal Explanations */}
      <section className={styles.legalSection}>
        <div className={styles.legalHeader}>
          <Info />
          <h2>{titles.officialInfo[language] || titles.officialInfo.AZ}</h2>
        </div>
        <div className={styles.legalContent}>
          {language === 'ENG' ? (
            <>
              <p>
                <strong>Working hours norms and legal basis:</strong> Under relevant articles of the Labor Code of the Republic of Azerbaijan, standard weekly working hours cannot exceed 40 hours. In a 40-hour work week, daily working time is 8 hours.
              </p>
              <p>
                <strong>Annual norm indicators ({activeYear}):</strong> In a 40-hour work week{' '}
                <strong>{activeSummary.workHours40.toLocaleString('en-US')} hours</strong>, in a 36-hour work week{' '}
                <strong>{activeSummary.workHours36.toLocaleString('en-US')} hours</strong>, in a 24-hour work week{' '}
                <strong>{activeSummary.workHours24.toLocaleString('en-US')} hours</strong>.
              </p>
              <p>
                * On work days preceding non-working holidays, voting days, and National Mourning Day, daily working hours are reduced by one hour.
              </p>
            </>
          ) : language === 'RU' ? (
            <>
              <p>
                <strong>Нормы рабочего времени и правовая основа:</strong> Согласно Трудовому кодексу Азербайджанской Республики, нормальная продолжительность рабочего времени не может превышать 40 часов в неделю. При 40-часовой рабочей неделе дневная норма составляет 8 часов.
              </p>
              <p>
                <strong>Годовые нормы ({activeYear}):</strong> При 40-часовой рабочей неделе{' '}
                <strong>{activeSummary.workHours40.toLocaleString('ru-RU')} часов</strong>, при 36-часовой{' '}
                <strong>{activeSummary.workHours36.toLocaleString('ru-RU')} часов</strong>, при 24-часовой{' '}
                <strong>{activeSummary.workHours24.toLocaleString('ru-RU')} часов</strong>.
              </p>
              <p>
                * В дни, предшествующие праздничным дням, дням голосования и Дню всенародной скорби, рабочий день сокращается на 1 час.
              </p>
            </>
          ) : language === 'TR' ? (
            <>
              <p>
                <strong>Çalışma süresi normları ve yasal dayanak:</strong> Azerbaycan Cumhuriyeti İş Kanunu uyarınca, haftalık tam çalışma süresi 40 saati aşamaz. Haftalık 40 saatlik çalışma düzeninde günlük çalışma süresi 8 saattir.
              </p>
              <p>
                <strong>Yıllık norm göstergeleri ({activeYear}):</strong> 40 saatlik çalışma haftasında{' '}
                <strong>{activeSummary.workHours40.toLocaleString('tr-TR')} saat</strong>, 36 saatlik çalışma haftasında{' '}
                <strong>{activeSummary.workHours36.toLocaleString('tr-TR')} saat</strong>, 24 saatlik çalışma haftasında{' '}
                <strong>{activeSummary.workHours24.toLocaleString('tr-TR')} saat</strong> olarak belirlenmiştir.
              </p>
              <p>
                * Resmi tatil günleri, seçim günleri ve Ulusal Yas Günü öncesindeki iş günlerinde günlük çalışma süresi bir saat kısaltılır.
              </p>
            </>
          ) : (
            <>
              <p>
                <strong>İş vaxtı norması və qanunvericilik bazası:</strong> Azərbaycan Respublikasının
                Əmək Məcəlləsinin müvafiq maddələrinə əsasən, həftəlik tam iş vaxtının müddəti 40 saatdan
                artıq ola bilməz. Həftəlik 40 saatlıq iş vaxtında gündəlik iş vaxtının müddəti 8 saatdır.
              </p>
              <p>
                <strong>İllik norma göstəriciləri ({activeYear}):</strong> 40 saatlıq iş həftəsində{' '}
                <strong>{activeSummary.workHours40.toLocaleString('az-AZ')} saat</strong>, 36 saatlıq iş həftəsində{' '}
                <strong>{activeSummary.workHours36.toLocaleString('az-AZ')} saat</strong>, 24 saatlıq iş həftəsində{' '}
                <strong>{activeSummary.workHours24.toLocaleString('az-AZ')} saat</strong> təşkil edir.
              </p>
              <p>
                * Bayramqabağı, səsvermə və Ümumxalq Hüzn Günü qabağı iş günlərində gündəlik iş vaxtının
                müddəti bir saat qısaldılır.
              </p>
            </>
          )}
        </div>
      </section>
    </section>
  )
}

export default Calendar
